export default "__VITE_ASSET__BkbcTmtl__"